import { RefObject, useEffect, useRef, useState } from 'react'

export const useOnScreenIntersection = (options: IntersectionObserverInit, ref: RefObject<any> | null) => {
  const [isIntersected, setIsIntersected] = useState<boolean>(false)
  const observerRef = useRef<IntersectionObserver | null>(null)

  useEffect(() => {
    observerRef.current = new IntersectionObserver(([IntersectionObserverEntry], observer) => {
      const {
        thresholds: [threshold],
      } = observer
      if (IntersectionObserverEntry.intersectionRatio === 0) {
        setIsIntersected(false)
        return
      }
      setIsIntersected(IntersectionObserverEntry.intersectionRatio < threshold)
    }, options)
  }, [options])

  useEffect(() => {
    if (!ref?.current) {
      return
    }
    observerRef.current?.observe(ref.current)

    return () => {
      observerRef.current?.disconnect()
    }
  }, [ref])

  return { isIntersected }
}
